/* États & limites — AI-04 (Bible §51 · ADM-10).
   Provider health, duplicate protection, failed-send retry. Access to review
   text is restricted and traced; the product never claims to be « trained on
   your reviews » without a precise, verified data declaration. */
import { Button, ErrorState, ListRow } from '@/ui'
import { useReviewHealth } from './api'
import { Chargement, Retour } from './parts'

export default function Etats() {
  const { data, isPending, isError, refetch } = useReviewHealth()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger l’état du service."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 760 }}>
      <Retour />
      <h2 className="t-page" style={{ margin: 0 }}>États &amp; limites</h2>

      <section>
        {data.map(h => (
          <ListRow key={h.id} title={h.title} meta={h.meta}
            end={h.kind === 'retry' ? <Button size="sm" variant="quiet">{h.label}</Button>
              : h.kind === 'action' ? <span className="pill pill-warn">◔ {h.label}</span>
              : <span className="pill pill-done">◷ {h.label}</span>} />
        ))}
      </section>

      <p className="f-help" style={{ margin: 0 }}>
        Le produit ne dit jamais «&nbsp;entraîné sur vos avis&nbsp;» sans déclaration de
        données précise et vérifiée. Accès au texte des avis&nbsp;: restreint, tracé.
      </p>
    </div>
  )
}
